// in src/SpotAnalyzer/CloneSpotAnalyzer.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';

class CloneSpotAnalyzer extends Component {

    handleClick = () => {
        let record = this.props.record;

        for (const property in record) {

            if(`${property}` === '@id' ||
                `${property}` === '@type'  ||
                `${property}` === 'import_file_id' ||
                `${property}` === 'added_to_dashboard' ||
                `${property}` === 'ready') {
                delete record[property];
            }
        }

        let source = encodeURIComponent(JSON.stringify(record));
        window.location.replace(`#/spot-analyzers/create?source=${source}`);
    }

    render() {
        return <Button variant="text" color="primary" size="small" onClick={this.handleClick}>
        <FileCopyIcon /> &nbsp; Copy
        </Button>;
    }
}

CloneSpotAnalyzer.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(CloneSpotAnalyzer);